/* global google */
import { Controller } from '@hotwired/stimulus';
import loadGoogleCharts from '../../views/dashboard/loader';

// Connects to data-controller="dashboard--chart"
//
// Desenha no connect(), não uma vez só no load da página: depois de um
// <turbo-stream replace> em #chart_div/#performance_chart (ver
// DashboardSnapshot::Broadcaster) o elemento é trocado por um novo — nenhum
// código de load inicial roda de novo, só o connect() do controller.
export default class extends Controller {
  static get values() {
    return { kind: String, late: Number, total: Number, data: Array };
  }

  connect() {
    loadGoogleCharts().then(() => {
      if (this.kindValue === 'pie') this.drawPie();
      else this.drawPerformance();
    });
  }

  drawPie() {
    google.charts.load('current', { packages: ['corechart'] });
    google.charts.setOnLoadCallback(() => {
      const data = new google.visualization.DataTable();
      data.addColumn('string', 'Tipo');
      data.addColumn('number', 'Total');
      data.addRows([
        ['Total', this.totalValue - this.lateValue],
        ['Atraso', this.lateValue],
      ]);

      const options = {
        colors: ['#ffc106', '#b8b8b4'],
        legend: {
          position: 'right',
        },
        chartArea: {
          width: '97%',
          height: '97%',
          left: 0,
          right: 0,
        },
      };

      const chart = new google.visualization.PieChart(this.element);
      chart.draw(data, options);
    });
  }

  drawPerformance() {
    google.charts.load('current', {
      packages: ['corechart'],
    });
    google.charts.setOnLoadCallback(() => {
      const chartData = google.visualization.arrayToDataTable(this.dataValue);

      const options = {
        legend: {
          position: 'top',
          textStyle: {
            fontSize: 10,
          },
        },
        colors: ['grey', 'orange', '#bfd264'],
        chartArea: {
          top: 30,
          height: '80%',
          width: '85%',
          right: 30,
          left: 30,
        },
        hAxis: {
          titleTextStyle: {
            color: 'black',
          },
          count: -1,
          viewWindowMode: 'pretty',
          slantedText: false,
          textStyle: {
            fontSize: 10,
          },
        },
        series: {
          0: {
            targetAxisIndex: 0,
          },
          1: {
            targetAxisIndex: 0,
          },
          2: {
            targetAxisIndex: 1,
            type: 'line',
            pointShape: 'circle',
          },
        },
        seriesType: 'bars',
        vAxes: {
          1: {
            viewWindowMode: 'explicit',
            viewWindow: {
              max: 110,
              min: 0,
            },
            gridlines: {
              color: '#eee',
            },
          },
        },
        pointSize: 7,
      };

      const chart = new google.visualization.ComboChart(this.element);
      chart.draw(chartData, options);
    });
  }
}
